@if (inDropdown()) {
	<ng-container *ngTemplateOutlet="calendar"></ng-container>
} @else {
	<div #anchor class="value-box" [class.calendar-open]="calendarOpen()" (click)="toggleOpenCalendar($event)">
		<div [class.placeholder]="!range()?.from || !range()?.to">{{ prettyFormat(range() ?? hoverRange(), view()) ?? placeholder() }}</div>
		@if (!calendarOpen() && allowClear() && range()?.from && range()?.to) {
			<app-icon class="icon" name="error" color="primary-1" (click)="clearDateRange($event)"></app-icon>
		} @else {
			<app-icon class="icon" name="kalender" color="typography-5" hoverColor="primary-1"></app-icon>
		}
	</div>
}
<ng-template #calendar>
	<app-calendar
		[data]="calendarData$"
		[begin]="calendarMonth$"
		[generateDay]="generateDay"
		[nrOfMonths]="1"
		class="small"
		[class.in-dropdown]="inDropdown()"
		[showWeekdays]="true"
		[showWeekends]="true"
		[showOtherMonthDates]="true"
		[showPreviousMonth]="(isPreviousMonthEnabled | async) ?? true"
		[showNextMonth]="(isNextMonthEnabled | async) ?? true"
		[showPreviousYear]="(isPreviousYearEnabled | async) ?? true"
		[showNextYear]="(isNextYearEnabled | async) ?? true"
		(onClick)="selectDate($event)"
		(onHover)="hoverDate($event)"
		(nextMonth)="nextMonth()"
		(previousMonth)="previousMonth()"
		(nextYear)="nextYear()"
		(previousYear)="previousYear()"
	></app-calendar>
</ng-template>
